export function getCannotView(profile) {
  return isAdminTI(profile) || isAudit(profile) ? false : true;
}

function isAdminTI(profile) {
  return profile === "adminTi" ? true : false;
}

function isAudit(profile) {
  return profile === "audit" ? true : false;
}